import React from 'react';

const StatCard = ({ icon, title, value, subtitle, onClick, color }) => (
  <div 
    className={`bg-white p-6 shadow-lg border-l-4 ${
      color === 'green' ? 'border-green-500' : 
      color === 'blue' ? 'border-blue-500' : 
      color === 'purple' ? 'border-purple-500' : 
      'border-[#c5a572]'
    } ${onClick ? 'cursor-pointer hover:shadow-xl transition-shadow' : ''}`} 
    onClick={onClick}
  >
    <div className="flex items-center gap-3 mb-3">
      <div className={color === 'green' ? 'text-green-600' : color === 'blue' ? 'text-blue-600' : color === 'purple' ? 'text-purple-600' : 'text-[#c5a572]'}>
        {icon}
      </div>
      <h3 className="text-sm uppercase tracking-wider text-[#5a6d62]">{title}</h3>
    </div>
    <p className="text-3xl text-[#1a2f23] font-display">{value}</p>
    <p className="text-sm text-[#5a6d62]">{subtitle}</p>
  </div>
);

export default StatCard;
